import React from 'react'
import PropTypes from 'prop-types'
import LogoHeader from './LogoHeader'

const Header = (props) => {

    return (
        <nav className="fixed-top">
            <div id="head0" className="d-flex row pt-2">
                <div className="d-flex justify-content-around col-md ml-4">
                    <small><a href="mailto:nritz.copy@gmail.com"><i className="icon fa-envelope mr-2"></i>nritz.copy@gmail.com</a></small>
                </div>

                <div className="d-flex justify-content-around col-md">
                    <small><a href="tel:+5511999594676"><i className="icon fa-phone mr-2"></i>(11) 99959-4676</a></small>
                </div>
                <div className="d-flex justify-content-around col-md">
                    <small><a href="https://instagram.com/nataliaritzmann/"><i className="icon fa-instagram mr-2"></i>@nataliaritzmann</a></small>
                </div>
            </div>

            <div id="head1" className="d-flex">
                <div className="d-flex justify-content-start col-md">
                    <LogoHeader goBackBtn={props.goBackBtn} />
                </div>

                <div className="d-flex justify-content-end col-md mt-2" style={{ cursor: 'pointer' }}>
                    <small className="menu-link" onClick={props.onToggleMenu} onKeyDown={props.onToggleMenu} role="link" href="#" tabIndex={0}>
                        <i className="icon fa-bars mr-2"></i>
                        Menu
                    </small>
                </div>
            </div>
        </nav>
    )
}
Header.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Header
